// extracted by mini-css-extract-plugin
export var howItWorks = "HowItWorks-module--how-it-works--7kwpI";
export var animationContainer = "HowItWorks-module--animation-container--bM0KF";